import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { TransitionService } from '@uirouter/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { DataService } from '../../../services/api/data.service';
import { StaticDataService } from '../../../services/api/static-data.service';
import { SessionService } from '../../../services/session/session.service';
import { SettingService } from '../../../services/setting.service';
import { ReportDialogService } from '../../../shared-components/report-dialog/report-dialog.service';
import { ExtraVacationHoursService } from '../company-extra-vacation-hours.services';
import * as i0 from "@angular/core";
import * as i1 from "../company-extra-vacation-hours.services";
import * as i2 from "../../../services/session/session.service";
import * as i3 from "../../../services/api/data.service";
import * as i4 from "../../../services/api/static-data.service";
import * as i5 from "../../../shared-components/report-dialog/report-dialog.service";
import * as i6 from "@uirouter/core";
import * as i7 from "../../../services/broadcast.service";
import * as i8 from "../../../services/setting.service";
var CompanyExtraVacationHoursComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyExtraVacationHoursComponent, _super);
    function CompanyExtraVacationHoursComponent(service, sessionService, dataService, staticDataService, reportDialogService, transitionService, broadcaster, settingService) {
        var _this = _super.call(this, dataService, staticDataService, settingService, sessionService, transitionService, broadcaster) || this;
        _this.service = service;
        _this.sessionService = sessionService;
        _this.dataService = dataService;
        _this.staticDataService = staticDataService;
        _this.reportDialogService = reportDialogService;
        _this.transitionService = transitionService;
        _this.broadcaster = broadcaster;
        _this.settingService = settingService;
        _this.refreshData = false;
        _this.gridDataSource = [];
        _this.spinnerOption = {
            max: undefined,
            min: undefined,
            step: 1,
            spinners: true,
            format: 'n2'
        };
        _this.isShowDataInvalidAlert = false;
        _this.isDataValid = true;
        _this.isShowAfterSaveSucess = false;
        _this.isSaing = false;
        _this.isSmallScreenValue = false;
        _this.ngUnsubscribe = new Subject();
        _this.service.showReportShortcutChange.pipe(takeUntil(_this.ngUnsubscribe)).subscribe(function (value) {
            if (value && _this.reportDialogService.isVisibleReportIcon) {
                _this.reportDialogService.onShowReportsEventClick();
            }
        });
        return _this;
    }
    Object.defineProperty(CompanyExtraVacationHoursComponent.prototype, "isSmallScreen", {
        get: function () {
            return this.isSmallScreenValue;
        },
        set: function (value) {
            if (value !== this.isSmallScreenValue) {
                this.isSmallScreenValue = value;
                this.refreshData = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    CompanyExtraVacationHoursComponent.prototype.onResize = function (event) {
        this.onScreenCheck();
    };
    CompanyExtraVacationHoursComponent.prototype.onScreenCheck = function () {
        this.isSmallScreen = window.innerWidth <= 1440;
    };
    Object.defineProperty(CompanyExtraVacationHoursComponent.prototype, "minCellWidth", {
        get: function () {
            return this.isSmallScreen ? 150 : undefined;
        },
        enumerable: true,
        configurable: true
    });
    CompanyExtraVacationHoursComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onScreenCheck();
        this.service.BalancesEmployeeViewByDate.pipe().subscribe(function (model) {
            // copy dirty records
            var arrayItemDirty = [];
            if (_this.service.originalDataBalancesEmployeeViewByDate &&
                _this.service.originalDataBalancesEmployeeViewByDate.length > 0) {
                arrayItemDirty = _this.service.originalDataBalancesEmployeeViewByDate.filter(function (item) { return item.isDirty === true; });
            }
            _this.gridDataSource = model;
            _this.gridDataSource.forEach(function (item) {
                if (item.HoursTotal || item.HoursTotal === 0) {
                    item.HoursTotal = parseFloat(parseFloat(item.HoursTotal).toFixed(2));
                }
                _this.caculateLeft(item);
                item.isDirty = false;
            });
            if (_this.service.isFirstLoad) {
                _this.service.isFirstLoad = false;
            }
            else {
                if (arrayItemDirty && arrayItemDirty.length > 0) {
                    arrayItemDirty.forEach(function (item) {
                        var recordDirty = _this.service.originalDataBalancesEmployeeViewByDate.find(function (find) { return find.UserEmploymentId === item.UserEmploymentId; });
                        if (recordDirty) {
                            recordDirty.isDirty = true;
                        }
                    });
                }
            }
        });
    };
    CompanyExtraVacationHoursComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    Object.defineProperty(CompanyExtraVacationHoursComponent.prototype, "isDirtyData", {
        get: function () {
            if (this.gridDataSource && this.gridDataSource.length > 0) {
                return this.gridDataSource.some(function (item) { return item.isDirty; });
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyExtraVacationHoursComponent.prototype, "isReadOnly", {
        get: function () {
            return this.sessionService.role.IsReadOnly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyExtraVacationHoursComponent.prototype, "isMobile", {
        get: function () {
            return this.sessionService.browser.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyExtraVacationHoursComponent.prototype, "isIOSApp", {
        get: function () {
            return this.sessionService.browser.isHybridApp && this.sessionService.browser.iOSMobileDevice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyExtraVacationHoursComponent.prototype, "isDisableSubmitButton", {
        get: function () {
            return this.isReadOnly || !this.service.effectivePer;
        },
        enumerable: true,
        configurable: true
    });
    CompanyExtraVacationHoursComponent.prototype.onGridSave = function (event) {
        if (event.dataItem) {
            event.dataItem.SpendHours =
                event.dataItem.SpendHours && event.dataItem.SpendHours > 0
                    ? event.dataItem.SpendHours * -1
                    : event.dataItem.SpendHours;
            event.dataItem.PayoutHours =
                event.dataItem.PayoutHours && event.dataItem.PayoutHours > 0
                    ? event.dataItem.PayoutHours * -1
                    : event.dataItem.PayoutHours;
            this.caculateLeft(event.dataItem);
        }
    };
    CompanyExtraVacationHoursComponent.prototype.onGridButtonClick = function (event) {
        var feildChnage = '';
        switch (event.buttonAction) {
            case 'MaxSpend':
                feildChnage = 'SpendHours';
                break;
            default:
                feildChnage = 'PayoutHours';
                break;
        }
        if (feildChnage) {
            if (event.dataItem['left'] === 0) {
                event.dataItem['disbaleMaxButton'] = true;
                return;
            }
            else {
                this.caculateMaxValue(feildChnage, event.dataItem);
            }
        }
    };
    CompanyExtraVacationHoursComponent.prototype.MaxFieldHours = function (field) {
        var _this = this;
        if (this.isReadOnly) {
            return;
        }
        this.gridDataSource.forEach(function (item) {
            if (item['left'] !== 0) {
                _this.caculateMaxValue(field, item);
            }
        });
    };
    CompanyExtraVacationHoursComponent.prototype.caculateMaxValue = function (feildMax, data) {
        if (data['left'] === 0) {
            data['disbaleMaxButton'] = true;
            return;
        }
        else {
            var leftValue = parseFloat(parseFloat(data['left']).toFixed(2));
            var dataFeildMax = data[feildMax] ? data[feildMax] : 0;
            data[feildMax] = leftValue * -1 + parseFloat(parseFloat(dataFeildMax).toFixed(2));
            data[feildMax] = parseFloat(parseFloat(data[feildMax]).toFixed(2));
            this.caculateLeft(data);
            this.refreshData = true;
        }
    };
    CompanyExtraVacationHoursComponent.prototype.caculateLeft = function (data) {
        var HoursTotalValues = data.HoursTotal ? data.HoursTotal : 0;
        var AdjustHoursValues = data.AdjustHours ? data.AdjustHours : 0;
        var SpendHoursValues = data.SpendHours ? data.SpendHours : 0;
        var PayoutHoursValues = data.PayoutHours ? data.PayoutHours : 0;
        data.left = this.sessionService.parseFloat(HoursTotalValues +
            (parseFloat(parseFloat(AdjustHoursValues).toFixed(2)) +
                parseFloat(parseFloat(SpendHoursValues).toFixed(2)) +
                parseFloat(parseFloat(PayoutHoursValues).toFixed(2))));
        data.left = parseFloat(parseFloat(data.left).toFixed(2));
        if (data.left < 0) {
            data.errorLeftClass = 'left-error';
            data['disbaleMaxButton'] = false;
        }
        else {
            data.errorLeftClass = '';
            data['disbaleMaxButton'] = false;
            if (data.left === 0) {
                data['disbaleMaxButton'] = true;
            }
        }
        data.isDirty = true;
    };
    CompanyExtraVacationHoursComponent.prototype.submitGridValues = function () {
        if (!this.isDirtyData) {
            return;
        }
        var request = {
            BalanceDefinitionId: 7,
            BalancePeriodId: null,
            PerDate: this.service.effectivePer
        };
        var DetailDataSource = [];
        var countError = 0;
        this.gridDataSource.forEach(function (item) {
            if (item.isDirty) {
                DetailDataSource.push({
                    UserEmploymentId: item.UserEmploymentId || null,
                    AdjustDays: null,
                    SpendDays: null,
                    MoveDays: null,
                    PayoutDays: null,
                    AdjustHours: item.AdjustHours || null,
                    SpendHours: item.SpendHours || null,
                    PayoutHours: item.PayoutHours || null
                });
                if (item.left < 0) {
                    countError += 1;
                }
            }
        });
        this.isDataValid = countError <= 0;
        if (this.isDataValid) {
            request.Details = DetailDataSource;
            if (request.Details && request.Details.length > 0) {
                this.save(request);
            }
        }
        else {
            this.isShowDataInvalidAlert = true;
        }
    };
    CompanyExtraVacationHoursComponent.prototype.onSubmitButtonClick = function () {
        var _this = this;
        setTimeout(function () {
            _this.submitGridValues();
        }, 500);
    };
    CompanyExtraVacationHoursComponent.prototype.save = function (model) {
        if (this.isSaing) {
            return;
        }
        this.isSaing = true;
        _super.prototype.save.call(this, model);
    };
    // public onEffecivePerKeyDown(event: any): void {
    //   if (event === 'Enter') {
    //     this.service.Reload_Balances_GetExtraVacationHours();
    //   }
    // }
    CompanyExtraVacationHoursComponent.prototype.afterSaveSucess = function (data) {
        var _this = this;
        if (data && data.length > 0) {
            data.forEach(function (item) {
                var itemAfterSave = _this.gridDataSource.find(function (model) { return model.UserEmploymentId === item.UserEmploymentId; });
                if (itemAfterSave) {
                    itemAfterSave.FullName = item.FullName;
                    itemAfterSave.BasedOnTemplateName = item.BasedOnTemplateName;
                    itemAfterSave.DepartmentName = item.DepartmentName;
                    itemAfterSave.ExternalReference = item.ExternalReference;
                    itemAfterSave.BaseAmount = item.BaseAmount || null;
                    itemAfterSave.AmountEarned = item.AmountEarned || null;
                    itemAfterSave.AmountTotal = item.AmountTotal || null;
                    itemAfterSave.HoursEarned = item.HoursEarned || null;
                    itemAfterSave.HoursSpent = item.HoursSpent || null;
                    itemAfterSave.HoursTotal = item.HoursTotal || null;
                    itemAfterSave.SecondaryDaysEarned = item.SecondaryDaysEarned || null;
                    itemAfterSave.SecondaryDaysSpent = item.SecondaryDaysSpent || null;
                    itemAfterSave.CurrentBalanceSecondaryDays = item.CurrentBalanceSecondaryDays || null;
                    itemAfterSave.SecondaryAmountTotal = item.SecondaryAmountTotal || null;
                    itemAfterSave.DaysEarned = itemAfterSave.DaysEarned + itemAfterSave.SecondaryDaysEarned;
                    itemAfterSave.DaysSpent = itemAfterSave.DaysSpent + itemAfterSave.SecondaryDaysSpent;
                    itemAfterSave.DaysTotal = itemAfterSave.DaysTotal + itemAfterSave.CurrentBalanceSecondaryDays;
                    itemAfterSave.AmountTotal = itemAfterSave.AmountTotal + itemAfterSave.SecondaryAmountTotal;
                    itemAfterSave.AdjustHours = null;
                    itemAfterSave.SpendHours = null;
                    itemAfterSave.PayoutHours = null;
                    _this.caculateLeft(itemAfterSave);
                    itemAfterSave.isDirty = false;
                }
            });
            this.refreshData = true;
        }
        this.isShowAfterSaveSucess = true;
    };
    CompanyExtraVacationHoursComponent.prototype.completeSave = function () {
        this.isSaing = false;
    };
    CompanyExtraVacationHoursComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompanyExtraVacationHoursComponent_Factory() { return new CompanyExtraVacationHoursComponent(i0.ɵɵinject(i1.ExtraVacationHoursService), i0.ɵɵinject(i2.SessionService), i0.ɵɵinject(i3.DataService), i0.ɵɵinject(i4.StaticDataService), i0.ɵɵinject(i5.ReportDialogService), i0.ɵɵinject(i6.TransitionService), i0.ɵɵinject(i7.BroadcastService), i0.ɵɵinject(i8.SettingService)); }, token: CompanyExtraVacationHoursComponent, providedIn: "root" });
    return CompanyExtraVacationHoursComponent;
}(ExtraVacationHoursService));
export { CompanyExtraVacationHoursComponent };
